import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FieldArgs, AutocompleteField } from '../types';
import InputLabel from '../../InputLabel/InputLabel';
import { useFormError } from '../utils';
import FormError from '../../FormError/FormError';
import Autocomplete from '../../Autocomplete/Autocomplete';
import get from 'lodash/get';
import FormControl from '../../FormControl/FormControl';

export type AutocompleteAdapterProps = FieldArgs<AutocompleteField> &
  Pick<
    React.ComponentProps<typeof Autocomplete>,
    'onInputChange' | 'isLoading' | 'clearOnBlur'
  >;

const AutocompleteAdapter = (props: AutocompleteAdapterProps) => {
  const {
    label,
    name,
    rules,
    options,
    multiple = false,
    onInputChange,
    isLoading,
    disabled,
    clearOnBlur,
  } = props;
  const {
    control,
    formState: { errors, defaultValues },
  } = useFormContext();
  const error = useFormError(get(errors, name));
  const defaultValue = get(defaultValues, name) || (multiple ? [] : null);

  return (
    <FormControl error={!!error} disabled={disabled}>
      <InputLabel>{label}</InputLabel>
      <Controller
        render={({ field: { value, onChange } }) => (
          <Autocomplete
            clearOnBlur={clearOnBlur}
            disabled={disabled}
            defaultValue={defaultValue}
            value={value ?? (multiple ? [] : null)}
            onChange={(event, value) => {
              onChange(value);
            }}
            multiple={multiple}
            options={options}
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            getOptionKey={(option) => option.value}
            onInputChange={onInputChange}
            isLoading={isLoading}
          />
        )}
        control={control}
        name={name}
        rules={rules}
      />
      <FormError error={error} />
    </FormControl>
  );
};

export default AutocompleteAdapter;
